import styled from "styled-components";

import { Button as CustomBtn } from '@lua-frontend/numu-ui';
import { ClipLoader } from "@lua-frontend/numu-ui";

const ButtonContainer = styled.div`
display: flex;
flex-direction: row;
justify-content: center;
width: 100%;
button {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 599px) {
  flex-direction: column-reverse;
  align-item: center;
  button {
    width: 100%;
    margin-bottom: 1rem;
  }
}
`;


export const StepperButtons = ({
    wrapperStyle = {},
    primaryProps = {},
    secondaryProps = {},
  }) => {
    const { style: pStyle = {}, text: primaryText, loading: primaryLoading =false, ...primary } = primaryProps;
    const { style: sStyle = {}, text: secondaryText, loading: secondaryLoading = false, ...secondary } = secondaryProps;

    const renderLoader = (color) => <ClipLoader size={20} loading={true} color= {color} />;
    
    return (
      <ButtonContainer style={{ ...wrapperStyle }}>
        {Object.keys(secondaryProps).length > 0 && (
          <CustomBtn
            style={{
              ...sStyle,
            }}
            text = {secondaryLoading ? renderLoader() : secondaryText}
            quaternary
            {...secondary}
          />
        )}
        {Object.keys(primaryProps).length > 0 && (
          <CustomBtn
            style={{
            ...pStyle }}
            text = {primaryLoading ? renderLoader(primary?.disabled ? "grey" : "white") : primaryText}
            {...primary}
          />
        )}
      </ButtonContainer>
    );
  };
  